import script from "./home-share-dialog-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./home-share-dialog-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__